import React, { useState, useEffect } from 'react';

import * as DOMPurify from 'dompurify';
import { extractPidValue } from '../utils';

const ParseHTML = ({ htmlString, variables }) => {
  const [transformedHTML, setTransformedHTML] = useState('');

  useEffect(() => {
    const transformString = (str, vars) => {
      let transformedString = DOMPurify.sanitize(str, { USE_PROFILES: { html: true } });
      if (!transformedString) return;

      for (const [key, trpls] of Object.entries(vars)) {
        const regex = new RegExp(`\\$\\{${key}\\}`, 'g');
        if (trpls && trpls[0] && trpls[0].val) {
          transformedString = transformedString.replace(regex, trpls[0].val);
        }
      }
      return transformedString;
    };

    if (htmlString && variables) {
      const trplPid = extractPidValue(htmlString);
      const trplValue = variables[trplPid] && variables[trplPid][0] && variables[trplPid][0].val;
      if (trplPid) {
        const transformedContent = transformString(htmlString, variables);
        if (trplValue) setTransformedHTML(transformedContent);
        else setTransformedHTML('');
      } else setTransformedHTML(htmlString);
    } else {
      setTransformedHTML(htmlString);
    }
  }, [htmlString, variables]);

  return (
    <div dangerouslySetInnerHTML={{ __html: transformedHTML }}/>
  );
};

export default ParseHTML;
